<template>
    <div v-if="hasCategoryHeaderImages" class="flex flex-col items-center">
        <img
            v-if="category.navImage"
            :alt="category.name"
            :src="category.navImage + '/-/format/auto/'"
            class="mb-2 h-14 sm:h-20 object-contain"
        />
        <div
            v-else
            class="crossed mb-2 w-full h-20 rounded border-2 border-gray-500"
        ></div>
        <span>{{ category.name }}</span>
    </div>
    <span v-else>{{ category.name }}</span>
</template>

<script>
export default {
    name: 'MenuStickyHeaderCategoryLabel',
    props: {
        category: {
            type: Object,
            required: true
        },
        hasCategoryHeaderImages: {
            type: Boolean,
            required: true
        }
    }
};
</script>
